module.exports = new __parcel__URL__("lexus-talk.ed3d608b.png").toString();